<template>
    <div>
        <b-modal size="xl" id="modal-prevent-closing" centered class="header-modal" no-close-on-backdrop hide-footer ref="modal-view-document">
            <div class="modal-view-document__body container wrap-form-create-update-chapter">
                <ViewDocument :isShowAnswer="true" :isEnableWork="false" class="wrap-view-document" :item="item" />
                <div class="modal__actions text-right">
                    <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel" @click="handleHideModal">
                        Đóng
                        <img class="icon-close" src="@/assets/img/x.png" alt="" />
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import ViewDocument from './ViewDocument'
import {
    TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK,
    TYPE_FILE_PDF, TYPE_FILE_POWERPOINT, TYPE_FILE_WORD, TYPE_FILE_EXCEL, TYPE_FILE_IMAGE
} from './../constants/constants_enum'

export default {
    name: "ModalViewDocument",
    components:{
        ViewDocument
    },
    props: {
        item: {
            type: Object,
            default: {}
        },
    },
    data() {
        return {
            confirmActive: {},
            isLoading: false,
            TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK,
            TYPE_FILE_PDF, TYPE_FILE_POWERPOINT, TYPE_FILE_WORD, TYPE_FILE_EXCEL, TYPE_FILE_IMAGE
        }
    },
    mounted(){
        this.handleShowModal()
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        
    },
    methods: {
        
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-view-document'].show()
        }
    }
}
</script>
<style lang="scss" scoped>
.icon-close{
    width: 15px;
}
.wrap-view-document{
    margin-top: 10px;
}
.modal-content {
    background-color: red;
}

.modal-view-document__body {
    height: 40rem;
    padding: 20px;
    background-color: white;
    .modal__actions{
        position: absolute;
        top: 0px;
        right: 0px;
        padding: 0px;
        .btn-delete{
            color: white;
            background: #fe0201;
            padding: 5px 20px 5px 20px;
            border-radius: 15px;
            font-family: sans-serif;
        }
        .btn-cancel{
            color: black;
            margin-right: 10px;
            font-family: sans-serif;
        }
    }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
</style>